// tiktokPrivacy — labels for TikTok's `privacy_level_options` values.
//
// 🔴 LINT ALLOWLIST FILE (decision D-006). One value below is literally
// "Obserwujący" / "Followers" — a word `forbidden_vocab_lint.py` bans everywhere
// else in the app. The ban exists so we never promise anyone an audience. This is
// the opposite of a promise: it is the name TikTok itself gives a visibility
// setting, and SPEC A7 requires us to show the platform's own option labels,
// without a default. The allowlist covers ONLY this file and ONLY the
// FOLLOWER_OF_CREATOR key — the same string anywhere else still fails CI.
//
// Keys are the raw platform constants on purpose: the options come from
// `creator_info` at runtime, so the UI looks up whatever the account actually
// offers. Never hardcode this list as the set of available choices.
export const tiktokPrivacy = {
  PUBLIC_TO_EVERYONE: 'Wszyscy',
  MUTUAL_FOLLOW_FRIENDS: 'Znajomi',
  FOLLOWER_OF_CREATOR: 'Obserwujący',
  SELF_ONLY: 'Tylko ja',
} as const
